import axios from 'axios';

function parseTimeout(value, fallback) {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : fallback;
}

const DEFAULT_TIMEOUT_MS = parseTimeout(process.env.REACT_APP_API_TIMEOUT_MS, 120000);
const LONG_REQUEST_TIMEOUT_MS = parseTimeout(process.env.REACT_APP_API_LONG_TIMEOUT_MS, 9000000);
const UPLOAD_TIMEOUT_MS = parseTimeout(process.env.REACT_APP_API_UPLOAD_TIMEOUT_MS, 0);
export const AUTH_TOKEN_STORAGE_KEY = 'zentis-token';
const LOCALHOST_REGEX = /^(localhost|127\.0\.0\.1)$/i;

function resolveBackendUrl() {
  const configured = process.env.REACT_APP_BACKEND_URL || '';
  if (typeof window === 'undefined') return configured;

  const host = window.location.hostname;
  const protocol = window.location.protocol || 'http:';
  const fallback = `${protocol}//${host}:8001`;
  if (!configured) return fallback;

  try {
    const parsed = new URL(configured);
    const targetHost = parsed.hostname;
    if (LOCALHOST_REGEX.test(targetHost) && !LOCALHOST_REGEX.test(host)) {
      return fallback;
    }
  } catch (e) {
    return fallback;
  }

  return configured;
}

const API = axios.create({
  baseURL: `${resolveBackendUrl()}/api`,
  timeout: DEFAULT_TIMEOUT_MS,
  maxBodyLength: Infinity,
  maxContentLength: Infinity,
});

export function getStoredAuthToken() {
  if (typeof localStorage === 'undefined') return null;
  return localStorage.getItem(AUTH_TOKEN_STORAGE_KEY);
}

export function setApiAuthToken(token) {
  if (token) {
    API.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(AUTH_TOKEN_STORAGE_KEY, token);
    }
  } else {
    delete API.defaults.headers.common['Authorization'];
    if (typeof localStorage !== 'undefined') {
      localStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
    }
  }
}

API.interceptors.request.use((config) => {
  const token = getStoredAuthToken();
  if (token && !config.headers?.Authorization) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function withTimeout(timeoutMs = LONG_REQUEST_TIMEOUT_MS) {
  return { timeout: timeoutMs };
}

export function withUploadTimeout(timeoutMs = UPLOAD_TIMEOUT_MS) {
  return { timeout: timeoutMs };
}

export function isTimeoutError(error) {
  return error?.code === "ECONNABORTED" || /timeout/i.test(error?.message || "");
}

export default API;
